module.exports = __webpack_public_path__ + "static/img/Horizontal shore 1,2 meter & 0,9 meter - Salin.250eff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Horizontal shore 1,2 meter & 0,9 meter - Salin.jpg
// module id = 81
// module chunks = 1